import { defaultParseError, parseString, sortLength } from "../utils";
export class DayStringSelection {
    constructor(propertyName, names, displayFields = {}) {
        this.propertyName = propertyName;
        this.names = names;
        this.displayFields = displayFields;
    }
    render(d) {
        const propertyValue = d[this.propertyName];
        if (propertyValue === null) {
            return '--';
        }
        return this.names[propertyValue];
    }
    parse(state) {
        return parseString(state, sortLength(this.names), null, defaultParseError(state));
    }
    get displayHours() {
        var _a;
        return (_a = this.displayFields.displayHours) !== null && _a !== void 0 ? _a : false;
    }
    get displayMinutes() {
        var _a;
        return (_a = this.displayFields.displayMinutes) !== null && _a !== void 0 ? _a : false;
    }
    get displaySeconds() {
        var _a;
        return (_a = this.displayFields.displaySeconds) !== null && _a !== void 0 ? _a : false;
    }
    get displayMilliseconds() {
        var _a;
        return (_a = this.displayFields.displayMilliseconds) !== null && _a !== void 0 ? _a : false;
    }
    get displayMicroseconds() {
        var _a;
        return (_a = this.displayFields.displayMicroseconds) !== null && _a !== void 0 ? _a : false;
    }
    get displayDate() {
        var _a;
        return (_a = this.displayFields.displayDate) !== null && _a !== void 0 ? _a : false;
    }
    get displayMonth() {
        var _a;
        return (_a = this.displayFields.displayMonth) !== null && _a !== void 0 ? _a : false;
    }
    get displayYear() {
        var _a;
        return (_a = this.displayFields.displayYear) !== null && _a !== void 0 ? _a : false;
    }
    get displayTimezone() {
        var _a;
        return (_a = this.displayFields.displayTimezone) !== null && _a !== void 0 ? _a : false;
    }
}
//# sourceMappingURL=DayStringSelection.js.map
